export enum LogType {
  Request = 1,
  Error = 2,
  Custom = 3,
}
